'use strict';

var _ = require('lodash');
var FaresOptimizerDateChartController = function FaresOptimizerDateChartController($scope, dateChartTransformationService, $timeout) {
  $scope.$watchCollection('chartData', function (chartData) {
    if (chartData && chartData.data) {
      var data = chartData.data;
      $scope.transformedData = !_.isEmpty(data) ? dateChartTransformationService.transformData(data, chartData.title, chartData) : data;
      $timeout(function () {
        $scope.renderChart($scope.transformedData);
      }, 0);
    }
  });
};
FaresOptimizerDateChartController.$inject = ['$scope', 'FaresOptimizerDateChartTransformationService', '$timeout'];
module.exports = FaresOptimizerDateChartController;